import React from "react";
import NotificationListBar from "./list";

const TaskMessages = ({ message }) => {
    return <>{message && (message.string || message.bullets.length > 0) && <NotificationListBar message={message.string} list={message.bullets} />}</>;
};

export default TaskMessages;
